import React from "react";
import Tooltip from "@mui/material/Tooltip";

export default function IneligibleHoursTooltip({ hours, detail }) {
  const [open, setOpen] = React.useState(false);
  const available = detail?.status === "live" && detail.rows?.length > 0 &&
    Math.round(detail.total_hours * 100) === Math.round(hours * 100);
  return (
    <Tooltip describeChild open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} disableTouchListener title={
      <div>
        <p className="font-semibold">Ineligible hours by job</p>
        {available ? <>
          <ul className="mt-1 space-y-1">{detail.rows.map((row, index) => <li key={index} className="flex justify-between gap-4"><span>{row.name}{row.reason === "unmapped" ? " (job not mapped)" : ""}</span><span className="tabular-nums">{row.hours.toFixed(2)} hrs</span></li>)}</ul>
          <p className="mt-2">Rightwork jobs during pool windows. Time eligible in any overlapping pool is excluded from this breakdown. Unmapped jobs need review; other listed jobs received no points in the covering pools.</p>
          <p className="mt-1">Rounded job hours add to the displayed total.</p>
        </> : <p className="mt-1">{detail?.reason || "Job detail is unavailable for these hours."}</p>}
      </div>
    }>
      <button type="button" className="block ml-auto rounded text-xs text-slate-400 hover:text-violet-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-600" onClick={(event) => { event.stopPropagation(); setOpen(true); }} onBlur={() => setOpen(false)} onKeyDown={(event) => { if (event.key === "Escape") { event.stopPropagation(); setOpen(false); } }} aria-label={`${hours.toFixed(2)} ineligible hours: show jobs`}>
        +{hours.toFixed(2)} ineligible
      </button>
    </Tooltip>
  );
}
